/*
 * PageLoadingComponent Messages
 *
 * This contains all the text for the PageLoadingComponent component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.PageLoadingComponent";

export default defineMessages(scope, {
  header: "This is the Loading scene!",
  loadingText: "Please wait while we verify your identity.",
});
